module.exports = __webpack_public_path__ + "static/media/025.9aa4e27e.jpg";